var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamondHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M0 6h4l3 8.6-7-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16 6h-4l-3 8.6 7-8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M8 15l-3-9h6l-3 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M4 5h-4l2-3 2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M16 5h-4l2-3 2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M10 5h-4l2-3 2 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M3.34 2h3.66l-2 3-1.66-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M9 2h4l-2 3-2-3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondHeader);
export default __webpack_public_path__ + "static/media/diamondHeader.598e2c784376643e9b24e629b55acd18.svg";
export { ForwardRef as ReactComponent };